var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 123.04,
    height: 78,
    viewBox: "0 0 123.04 78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(-429.988 -214)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(429.988 214)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M550.667,189.5l27.909-13.229L606,189.5V229.5H594.708V201.756H562.443V229.5H550.667Z",
    transform: "translate(-550.667 -176.267)",
    fill: "#114e8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M826.533,189.873l2.742-1.207,23.069,11.262v40.06h-8.792v-41.91Z",
    transform: "translate(-784.811 -186.791)",
    fill: "#135ca3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M826.533,189.792l2.742-1.125,23.069,10.5v37.344h-8.792V197.44Z",
    transform: "translate(-757.285 -183.313)",
    fill: "#428fda"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M826.533,189.834l2.742-1.168,23.069,10.9v38.761h-8.792V197.773Z",
    transform: "translate(-771.199 -185.128)",
    fill: "#1669ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M826.533,189.752l2.742-1.086L852.345,198.8v36.046h-8.792V197.135Z",
    transform: "translate(-743.673 -181.649)",
    fill: "#95c0ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M826.533,189.71l2.742-1.043,23.069,9.735v34.629h-8.792V196.8Z",
    transform: "translate(-729.305 -179.834)",
    fill: "#e8f1fb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(14.597 32.484)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 6.22,
    height: 5.529,
    transform: "translate(0 7.603)",
    fill: "#f06c00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 6.22,
    height: 5.529,
    transform: "translate(7.603 7.603)",
    fill: "#f06c00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 6.22,
    height: 6.22,
    transform: "translate(0 14.514)",
    fill: "#f06c00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    width: 6.22,
    height: 6.22,
    transform: "translate(7.603 14.514)",
    fill: "#f06c00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    width: 6.22,
    height: 6.22,
    transform: "translate(15.205 14.514)",
    fill: "#f06c00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 6.22,
    height: 5.529,
    fill: "#f06c00"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "ORIGINPICK",
    transform: "translate(1.012 72)",
    fill: "#f06c00",
    fontSize: 22,
    fontFamily: "MaryAnn-Bold, Mary Ann",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "ORIGINPICK"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.52543f1f6fcbeb1a302b459efeebfb77.svg";
export { ForwardRef as ReactComponent };